import React, { Component } from 'react';
import Loader from '../../_helpers/Loader';
import DataTable from 'react-data-table-component';
import { adminservice } from '../../services/admin.service';
import { historypush } from '../../_helpers/utilities';
import DeleteMember from './Component/DeleteMember';
import { isStringEmpty } from '../../_helpers/string_helper';
import { UncontrolledTooltip } from 'reactstrap';
import DeleteStudent from './Component/DeleteStudent';
import UploadExcelFile from './Component/UploadExcelFile';
import { UIGridToSheet,SheetToArrayBuffer } from '../../_helpers/utilities';

const paginationComponentOptions = {
    noRowsPerPage:true,
};

const XLSX = require("xlsx"); 

class MemberList extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isLoading:false,
            memberList:[],
            originalMemberList:[],
            totalRows:'',
            noOfRecordsToFetch:50,
            paginationDefaultPage:1,
            selectedMemberToDelete:'',
            selectedStudentToDelete:'',
            showSuccessMessage:false,
            showMemberDeleteModel:false,
            showStudentDeleteModel:false,
            studentClicked:false,
            studentList:[],
            searchValue:'',
            showUploadPopup:false,
            memberListToExport:[],
            studentListToExport:[],
            isActive:true,
        };
    }

    componentDidMount=async()=> {
        localStorage.removeItem("EditMemberId");
        localStorage.removeItem("EditUserId");
        const Role = localStorage.getItem("RoleId");

        if(Role == 1 || Role == 4){
            if(localStorage.getItem("StudentDetails") === "Show"){
                this.setState({studentClicked:true});
                this.getStudentList();
            }else{
                this.setState({studentClicked:false});
                this.getMemberList();
            }
        }else{
            historypush('/login');
        }
    }

    getMemberList=async(page = undefined)=>{
        try{
            const{noOfRecordsToFetch,searchValue,isActive}=this.state;
            let prevPageValue = page ? noOfRecordsToFetch * (page - 1) : 0;
            var pageNumber  = page == undefined ? 1 : page;
            this.setState({isLoading:true, paginationDefaultPage: pageNumber})
            var response=await adminservice.GetMemberList(prevPageValue,noOfRecordsToFetch,searchValue,isActive);
            if(response.status === 200){
                if(response.data.length > 0){
                    this.setState({
                        memberList:response.data,
                        originalMemberList:response.data,
                        totalRows:response.data[0].totalRows,
                    })
                }else{
                    this.setState({
                        memberList:[],
                        totalRows:0,
                    })
                }
                this.setState({isLoading:false})
            }else if(response.status===401){
                this.setState({isLoading:false})
                localStorage.clear();
                historypush('/login');
            }else{
                this.setState({isLoading:false})
            }
        }
        catch(e){
            return ""
        }
    }

    getStudentList=async(page = undefined)=>{
        try{
            const{noOfRecordsToFetch,searchValue,isActive}=this.state;
            let prevPageValue = page ? noOfRecordsToFetch * (page - 1) : 0;
            var pageNumber  = page == undefined ? 1 : page;
            this.setState({isLoading:true, paginationDefaultPage: pageNumber})
            var response=await adminservice.GetStudentList(prevPageValue,noOfRecordsToFetch,searchValue,isActive);
            if(response.status === 200){
                if(response.data.length > 0){
                    this.setState({
                        studentList:response.data,
                        totalRows:response.data[0].totalRows,
                        isLoading:false,
                    })
                }else{
                    this.setState({
                        studentList:[],
                        totalRows:0,
                        isLoading:false,
                    })
                }
            }else if(response.status===401){
                localStorage.clear();
                historypush('/login');
                this.setState({isLoading:false})
            }else{
                this.setState({isLoading:false})
            }
        }
        catch(e){
            return ""
        }
    }

    Header = (isActive) => {
        return[
        {
          name: <div >Sr. No.</div>,
          selector: (row) => row.serialNumber,
          left: true,
          width:'90px',
        },
        {
            name: <div>Member No.</div>,
            selector: (row) => row.memberNumber,
            left: true,
            width:'120px',
        },
        {
            name: <div className="question-doc">Member Name</div>,
            selector: (row) => <div key={row.memberNumber}>
                <span className="view" id={'UncontrolledTooltipStatus' + row.memberNumber} > {row.firstName}</span> 
                <UncontrolledTooltip placement="top" target={'UncontrolledTooltipStatus' + row.memberNumber}>
                {row.firstName}
                </UncontrolledTooltip>
            </div>,
            left: true,
            width:'200px',
        },
        {
            name: <div className="question-doc">Member Address</div>,
            selector: (row) => <div key={row.memberNumber}>
                <span className="view" id={'UncontrolledTooltiphouse' + row.memberNumber} > {row.houseNo}</span> 
                <UncontrolledTooltip placement="top" target={'UncontrolledTooltiphouse' + row.memberNumber}>
                {row.houseNo}
                </UncontrolledTooltip>
            </div>,
            left: true,
            width:'197px',
        },
        {
            name: <div>Branch</div>,
            selector: (row) => row.branch,
            left: true,
            width:'100px',
            wrap:true,
        },
        {
            name: <div className="question-doc">Email Address</div>,
            selector: (row) => <div key={row.memberNumber}>
            <span className="view" id={'UncontrolledTooltipemail' + row.memberNumber} > {row.email}</span> 
            <UncontrolledTooltip placement="top" target={'UncontrolledTooltipemail' + row.memberNumber}>
            {row.email}
            </UncontrolledTooltip>
            </div>,
            left: true,
            width:'120px',
        },
        {
            name: <div className="question-doc">Grade</div>,
            selector: (row) => <div key={row.memberNumber}>
                <span className="view" id={'UncontrolledTooltipgrade' + row.memberNumber} > {row.grade}</span> 
                <UncontrolledTooltip placement="top" target={'UncontrolledTooltipgrade' + row.memberNumber}>
                {row.grade}
                </UncontrolledTooltip>
            </div>,
            left: true,
            width:'100px',
            wrap:true,
        },
        {
            name: <div>Edit</div>,
            selector: (row) => <td style={{cursor:'pointer'}} className="download" onClick={()=>this.editMember(row)}><i className="fa fa-pencil-square-o" style={{fontSize:'20px'}} href="#" /></td>,
            center: true,
            width:'100px',
            omit: isActive ? false :true,
        },
        {
            name: <div>Delete</div>,
            selector: (row) => <td style={{cursor:'pointer'}} className="delete" onClick={()=>this.DeleteModel(row)}><i className="fa fa-trash" style={{fontSize:'20px'}} data-bs-toggle="modal" data-bs-target="#myModal1" /></td>,
            center: true,
            width:'auto',
            omit: isActive ? false :true,
        }
    ]
}

    StudentHeader = (isActive) => {
        return[
        {
            name: <th>Sr. No.</th>,
            selector: (row) => row.srNo,
            left: true,
            width:'65px',
        },
        {
            name: <th>User Code</th>,
            selector: (row) => <div key={row.userId}>
                <span className="view" id={'UncontrolledTooltipstuduserCode' + row.userId} > {row.userCode}</span> 
                <UncontrolledTooltip placement="top" target={'UncontrolledTooltipstuduserCode' + row.userId}>
                {row.userCode}
                </UncontrolledTooltip>
            </div>,
            left: true,
            width:'120px',
        },
        {
            name: <th className="question-doc">Student Name</th>,
            selector: (row) =><div key={row.userId}>
                <span className="view" id={'UncontrolledTooltipstudname' + row.userId} > {row.userName}</span> 
                <UncontrolledTooltip placement="top" target={'UncontrolledTooltipstudname' + row.userId}>
                {row.userName}
                </UncontrolledTooltip>
            </div>,
            left: true,
            width:'135px',
        },
        {
            name: <th className="question-doc">Student Address</th>,
            selector: (row) => <div key={row.userId}>
            <span className="view" id={'UncontrolledTooltipstudadd' + row.userId} > {row.address}</span> 
            <UncontrolledTooltip placement="top" target={'UncontrolledTooltipstudadd' + row.userId}>
            {row.address}
            </UncontrolledTooltip>
        </div>,
            left: true,
            width:'180px',
        },
        {
            name: <th className="question-doc">Email Address</th>,
            selector: (row) => <div key={row.userCode}>
                <span className="view" id={'UncontrolledTooltipstudemail' + row.userId} > {row.email}</span> 
                <UncontrolledTooltip placement="top" target={'UncontrolledTooltipstudemail' + row.userId}>
                {row.email}
                </UncontrolledTooltip>
            </div>,
            center: true,
            width:'155px',
        },
        {
            name: <th>Phone Number</th>,
            selector: (row) => row.mobileNumber,
            center: true,
            width:'auto',
        },
        {
            name: <th>Edit</th>,
            selector: (row) => <td style={{cursor:'pointer'}} className="download" onClick={()=>this.editStudent(row)}><i className="fa fa-pencil-square-o" style={{fontSize:'20px'}} href="#" /></td>,
            center: true,
            width:'100px',
            omit: isActive ? false :true,
        },
        {
            name: <th>Delete</th>,
            selector: (row) => <td style={{cursor:'pointer'}} className="delete" onClick={()=>this.DeleteStudentModel(row)}><i className="fa fa-trash" style={{fontSize:'20px'}} data-bs-toggle="modal" data-bs-target="#myModal1" /></td>,
            center: true, 
            width:'100px', 
            omit: isActive ? false :true,
        }
    ]
}

    DeleteModel=(row)=>{
        this.setState({
            selectedMemberToDelete:row.memberId,
            showMemberDeleteModel:true,
        })
    }

    DeleteStudentModel=(row)=>{
        this.setState({
            selectedStudentToDelete:row.userId,
            showStudentDeleteModel:true,
        })
    }

    editMember=(row)=>{
        localStorage.setItem("EditMemberId", row.memberId);
        historypush('/memberregistration');
    }

    editStudent=(row)=>{
        localStorage.setItem("EditUserId", row.userId);
        historypush('/registration');
    }

    closeDeleteModel=()=>{
        this.setState({
            showMemberDeleteModel:false,
            showStudentDeleteModel:false,
        })
    }
  
    goBack=()=>{
        localStorage.removeItem("StudentDetails");
        historypush('/admindashboard');
    }

    onSearchTextChange = async(event) => {
        var inputValue = event.target.value;
     
        this.setState({
            searchValue: inputValue,
        })
    };

    onSearchClick=()=>{
        if(isStringEmpty(this.state.searchValue))
        {
            if(this.state.studentClicked){
                this.getStudentList();
            }else{
                this.getMemberList();
            }
        }
        else{
            this.setState({
                isLoading:true,
            });
                if(this.state.studentClicked){
                    this.getStudentList();
                }else{
                    this.getMemberList();
                }
        }
    }
    
    addNewMemberPage=()=>{
        historypush('/memberregistration');
    }

    showUploadModel=()=>{
        this.setState({
            showUploadPopup:true,
        })
    }

    closeModel=()=>{
        this.setState({showUploadPopup:false});
    }

    closeSuccessModel=()=>{
        //this.setState({showSuccessMessage:true,showUploadPopup:false});
        setTimeout(()=>{
            this.closeMessage()
        },3000)
        
        if(this.state.studentClicked){
            this.getStudentList();
        }else{
            this.getMemberList();
        }
    }

    closeMessage=()=>{
        this.setState({showUploadPopup:false});
    }

    /* <summary>
    date: 22-08-2022
    Name: VD
    description: This is used to download the Member template which the admin can fill and upload
    <summary>*/ 
    downloadMemberTemplate = async () => {
        try {
          var sheetName = "sheet1";
          var wopts = { bookType: "xlsx", bookSST: true, type: "binary" };
          var columns = [
            "MEM_NO",
            "SERIAL_NO",
            "FORENAME",
            "SURNAME",
            "BRANCH",
            "EMAIL_ADDR",
            "GRADE",
            "ADDRESS_1",
            "ADDRESS_2",
            "ADDRESS_3",
            "PIN_CODE",
            "MEM_PASSWORD",
            "LEVEL 1 CLASSIFICATION",
            "LEVEL 2 CLASSIFICATION",
            "LANDLINE_NO",
            "MOBILE_NO",
          ];
          var data = [];
    
          var wb = XLSX.utils.book_new();
          var ws = UIGridToSheet(data, columns);
    
          XLSX.utils.book_append_sheet(wb, ws, sheetName);
          var wbout = XLSX.write(wb, wopts);
          const url = window.URL.createObjectURL(
            new Blob([SheetToArrayBuffer(wbout)], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Member Template.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
        } catch (error) {
          this.setState({
            showPopupModal: true,
            
          });
        }
    };

    /* <summary>
    date: 22-08-2022
    Name: VD
    description: This is used to download the Student template which the admin can fill and upload
    <summary>*/ 
    downloadStudentTemplate = async () => {
        try {
          var sheetName = "sheet1";
          var wopts = { bookType: "xlsx", bookSST: true, type: "binary" };
          var columns = [
            "USER_NAME",
            "DOB",
            "NATIONALITY",
            "RECEIPTNO",
            "SERIALNO",
            "RECEIPT_DATE",
            "PASSPORTNO",
            "PASSPORT_DOI",
            "CDC_NO",
            "CDC_DOI",
            "CDC_PLACE_ISSUE",
            "ADDRESS",
            "COUNTRY",
            "WHATSAPP_NO",
            "MOBILE_NO",
            "EMAIL",
            "CONTACT_NO",
            "CONTACT_ADDR",
            "INSTITUTE_NAME",
            "COURSE_NAME",
            "INSTITUE_ADDR",
            "JOINING_DATE",
            "COMPLETION_DATE",
            "P_TAR_BOOK_NO",
            "COLLECTION",
            "PAYMENT",
          ];
          var data = [];
    
          var wb = XLSX.utils.book_new();
          var ws = UIGridToSheet(data, columns);
    
          XLSX.utils.book_append_sheet(wb, ws, sheetName);
          var wbout = XLSX.write(wb, wopts);
          const url = window.URL.createObjectURL(
            new Blob([SheetToArrayBuffer(wbout)], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Student Template.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
        } catch (error) {
          this.setState({
            showPopupModal: true,
            
          });
        }
    };
      
    /* <summary>
    date: 22-08-2022
    Name: VD
    description: This is used to check which tmeplate the user wants to download
    <summary>*/ 
    templateDownload=()=>{
        if(this.state.studentClicked){
            this.downloadStudentTemplate();
        }else{
            this.downloadMemberTemplate();
        }
    }

    /* <summary>
    date: 24-08-2022
    Name: VD
    description: This is used to check if the admin is in student or member page
    <summary>*/ 
    exportFile=()=>{
        if(this.state.studentClicked){
            this.downloadStudentExportData();
        }else{
            this.downloadMemberExportData();
        }
    }

    /* <summary>
    date: 24-08-2022
    Name: VD
    description: This is used to get all the records of member to bind in the export list
    <summary>*/ 
    downloadMemberExportData=async()=>{
        try{
            this.setState({isLoading:true})
            var response= await adminservice.ExportMemberDetails(this.state.isActive);
            if(response.status === 200){
                this.setState({memberListToExport:response.data});
                this.bindExportMemberData(response.data);
                this.setState({isLoading:false})
            }
        }catch(e){

        }
    }

    /* <summary>
    date: 24-08-2022
    Name: VD
    description: This is used to get all the records of member to bind in the export list
    <summary>*/ 
    downloadStudentExportData=async()=>{
        try{
            this.setState({isLoading:true})
            var response= await adminservice.ExportStudentDetails(this.state.isActive);
            if(response.status === 200){
                this.setState({studentListToExport:response.data});
                this.bindExportStudentData(response.data);
                this.setState({isLoading:false})
            }
        }catch(e){

        }
    }
    
    /* <summary>
    date: 24-08-2022
    Name: VD
    description: This is used to bind the member data in the excel to export
    <summary>*/ 
    bindExportMemberData = (data) => {
        try {
          var dataToAdd = [...data].map((item) => item);
          var sheetName = "sheet1";
          var wopts = { bookType: "xlsx", bookSST: true, type: "binary" };
          var columns = [
            "MEM_NO",
            "SERIAL_NO",
            "FORENAME",
            "SURNAME",
            "BRANCH",
            "EMAIL_ADDR",
            "GRADE",
            "CREATED_DATE",
            "ADDRESS_1",
            "ADDRESS_2",
            "ADDRESS_3",
            "PIN_CODE",
            "MEM_PASSWORD",
            "RESET_DATE",
            "LEVEL 1 CLASSIFICATION",
            "LEVEL 2 CLASSIFICATION",
            "LANDLINE_NO",
            "MOBILE_NO",
          ];
    
          //width
          var wscols = [
            { wch: 15 },
            { wch: 15 },
            { wch: 25 },
            { wch: 25 },
            { wch: 15 },
            { wch: 35 },
            { wch: 15 },
            { wch: 35 },
            { wch: 35 },
            { wch: 35 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 35 },
            { wch: 35 },
            { wch: 25 },
            { wch: 25 },
          ];
    
          var data = [];
          dataToAdd.forEach((element) => {
            // const badgeNumberCommaString = element.map(
            //   (x) => x.badgeNumber
            // ).join(",");
    
            data.push([
              element["meM_NO"],
              element["seriaL_NO"],
              element["forename"],
              element["surname"],
              element["branch"],
              element["emaiL_ADDR"],
              element["class"],
              element["createD_DATE"],
              element["addresS_1"],
              element["addresS_2"],
              element["addresS_3"],
              element["piN_CODE"],
              element["meM_PASSWORD"],
              element["reseT_DATE"],
              element["classificationLevel1Name"],
              element["classificationLevel2Name"],
              element["landlinE_NO"],
              element["mobilE_NO"],
            ]);
          });
          var wb = XLSX.utils.book_new();
          var ws = UIGridToSheet(data, columns);
    
          //width
          ws["!cols"] = wscols;
    
          XLSX.utils.book_append_sheet(wb, ws, sheetName);
          var wbout = XLSX.write(wb, wopts);
          const url = window.URL.createObjectURL(
            new Blob([SheetToArrayBuffer(wbout)], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Members Data.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
          // saveAs(
          //   new Blob([this.s2ab(wbout)], { type: "application/octet-stream" }),
          //   fileName
          // );
        } catch (error) {
          
        }
    };
    
    /* <summary>
    date: 24-08-2022
    Name: VD
    description: This is used to bind the User data in the excel to export
    <summary>*/ 
    bindExportStudentData = (data) => {
        try {
          var dataToAdd = [...data].map((item) => item);
          var sheetName = "sheet1";
          var wopts = { bookType: "xlsx", bookSST: true, type: "binary" };
          var columns = [
            "USER_NAME",
            "PASSWORD",
            "USER_CODE",
            "CREATED_DATE",
            "CANDIDATE_NAME",
            "DOB",
            "NATIONALITY",
            "PASSPORTNO",
            "PASSPORT_DOI",
            "CDC_NO",
            "CDC_DOI",
            "CDC_PLACE_ISSUE",
            "ADDRESS",
            "COUNTRY",
            "WHATSAPP_NO",
            "MOBILE_NO",
            "EMAIL",
            "CONTACT_ADDR",
            "CONTACT_NO",
            "INSTITUTE_NAME",
            "INSTITUE_ADDR",
            "COURSE_NAME",
            "JOINING_DATE",
            "COMPLETION_DATE",
            "P_TAR_BOOK_NO",
            "COLLECTION",
            "PAYMENT",
            "ONBOARD_TAR_BOOK_NO",
            "RECEIPTNO",
            "SERIALNO",
            "RECEIPT_DATE",
          ];
    
          //width
          var wscols = [
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 25 },
            { wch: 25 },
            { wch: 15 },
            { wch: 35 },
            { wch: 15 },
            { wch: 35 },
            { wch: 35 },
            { wch: 35 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
          ];
    
          var data = [];
          dataToAdd.forEach((element) => {
            // const badgeNumberCommaString = element.map(
            //   (x) => x.badgeNumber
            // ).join(",");
    
            data.push([
              element["useR_NAME"],
              element["password"],
              element["useR_CODE"],
              element["createD_DATE"],
              element["candidatE_NAME"],
              element["dob"],
              element["nationality"],
              element["passportno"],
              element["passporT_DOI"],
              element["cdC_NO"],
              element["cdC_DOI"],
              element["cdC_PLACE_ISSUE"],
              element["address"],
              element["country"],
              element["whatsapP_NO"],
              element["mobilE_NO"],
              element["email"],
              element["contacT_ADDR"],
              element["contacT_NO"],
              element["institutE_NAME"],
              element["instituE_ADDR"],
              element["coursE_NAME"],
              element["joininG_DATE"],
              element["completioN_DATE"],
              element["p_TAR_BOOK_NO"],
              element["collection"],
              element["payment"],
              element["onboarD_TAR_BOOK_NO"],
              element["receiptno"],
              element["serialno"],
              element["receipT_DATE"],
            ]);
          });
          var wb = XLSX.utils.book_new();
          var ws = UIGridToSheet(data, columns);
    
          //width
          ws["!cols"] = wscols;
    
          XLSX.utils.book_append_sheet(wb, ws, sheetName);
          var wbout = XLSX.write(wb, wopts);
          const url = window.URL.createObjectURL(
            new Blob([SheetToArrayBuffer(wbout)], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Students Data.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
          // saveAs(
          //   new Blob([this.s2ab(wbout)], { type: "application/octet-stream" }),
          //   fileName
          // );
        } catch (error) {
          
        }
    };

    onstatusChange=(e)=>{
        if(e.target.value == "Inactive"){
            this.setState({
                isActive:false, 
            },async()=>{
                if(this.state.studentClicked){
                    this.getStudentList();
                }else{
                    this.getMemberList();
                }
            })
        }else{
            this.setState({
                isActive:true, 
            },async()=>{
                if(this.state.studentClicked){
                    this.getStudentList();
                }else{
                    this.getMemberList();
                }
            })
        }
        
    }

    render() {
        const{
            isLoading,
            memberList,
            totalRows,
            selectedMemberToDelete,
            selectedStudentToDelete,
            showMemberDeleteModel,
            showStudentDeleteModel,
            studentClicked,
            studentList,
            searchValue,
            showUploadPopup,
            showSuccessMessage,
            slectedGrade
        }=this.state;
        return (
            <div className="member-body">
                {isLoading && <Loader />}
                <div className="about">
                <div className="container">
                    <div className="row">
                    <div className="col-md-4"><h2 className="heading">{studentClicked ?"Student Details":"Member Details"}</h2></div>
                   <div className="col-md-8 member-mob">
                        <button type="button" onClick={()=>this.exportFile()} className="btn Submit-btn" style={{backgroundColor: '#4B7BB0', padding: '7px 25px', float: 'right', marginLeft:'10px'}}>
                        <a style={{textDecoration: 'none', color: 'white',cursor:'pointer'}}>Export</a>
                        </button>	
                        
                    {!studentClicked?
                        <button type="button" onClick={this.showUploadModel} className="btn Submit-btn " style={{backgroundColor: '#4B7BB0', padding: '7px 25px', float: 'right',  marginLeft:'10px'}}>
                        <a style={{textDecoration: 'none', color: 'white',cursor:'pointer'}}>Upload</a>
                        </button>
                    :""}
                    
                    {!studentClicked?
                        <button type="button" onClick={()=>this.templateDownload()} className="btn Submit-btn" style={{backgroundColor: '#4B7BB0', padding: '7px 25px', float: 'right', marginLeft:'10px'}}>
                        <a style={{textDecoration: 'none', color: 'white',cursor:'pointer'}}>Download Template</a>
                        </button>
                    :""}
                    {!studentClicked?
                        <button type="button" onClick={()=>this.addNewMemberPage()} className="btn Submit-btn" style={{backgroundColor: '#4B7BB0', padding: '7px 25px', float: 'right'}}>
                        <a href='' style={{textDecoration: 'none', color: 'white',cursor:'pointer'}}>Add New Member</a>
                        </button>
                    :""}
                    </div>
                    <div className="col-md-6">
                        <div>
                            <table>
                            <tbody><tr><td><h6 style={{fontSize: '20px', marginRight: '10px'}}>Filter by</h6></td>
                                <td>
                                    <select 
                                        className="form-select" 
                                        aria-label=".form-select-lg example" 
                                        style={{margin: '6px 0px'}}
                                        value={slectedGrade}
                                        onChange={(e)=>this.onstatusChange(e)}
                                    >
                                        <option value={"Active"}>Active</option>
                                        <option value={"Inactive"}>Inactive</option>
                                    </select>
                                </td>
                                </tr>
                            </tbody></table>
                        </div>
                        </div>
                    <div className="col-md-6 topnav">
                    <div className="search-container" style={{position:'relative',float:'right',marginRight:'37px'}}>
                        <input 
                            type="text" 
                            placeholder="Search.." 
                            name="search" 
                            value={searchValue}
                            onChange={this.onSearchTextChange.bind(this)}
                            />
                        <button type="submit" style={{position:'absolute', marginLeft:'2px'}} onClick={()=>this.onSearchClick()}><i className="fa fa-search" /></button>
                    </div>
                    </div>
                    </div>
                    <div className="table-responsive">
                    {studentClicked === true ?
                        <DataTable
                            columns={this.StudentHeader(this.state.isActive)}
                            data={studentList}
                            noHeader={true}
                            fixedHeader={true}
                            fixedHeaderScrollHeight="450px"
                            pagination
                            paginationServer
                            paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={this.getStudentList}
                            onChangePage={this.getStudentList}
                            //paginationRowsPerPageOptions={[]}
                            paginationComponentOptions={paginationComponentOptions}
                            paginationPerPage ={50}
                            style={{maxHeight:'100%'}}
                        />
                    :
                        <DataTable
                            columns={this.Header(this.state.isActive)}
                            data={memberList}
                            noHeader={true}
                            fixedHeader={true}
                            fixedHeaderScrollHeight="450px"
                            pagination
                            paginationServer
                            paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={this.getMemberList}
                            onChangePage={this.getMemberList}
                            //paginationRowsPerPageOptions={[]}
                            paginationComponentOptions={paginationComponentOptions}
                            paginationPerPage ={50}
                            style={{maxHeight:'100%'}}
                        />
                    }
                    <button type="button" onClick={()=>this.goBack()} className="question-button btn btn-white">Back</button>
                    </div>
                </div>
                </div>
                {showSuccessMessage && (
                    <div id="thank_you" className="alert alert-success" style={{ fontSize: '24px',position:'fixed',bottom:'100px',margin:"0 201px", width:"75%"}}>
                        Success! You have successfully registered.
                        <button type="button" className="btn-close" data-bs-dismiss="alert" style={{float:"right"}}/>
                    </div>
                )}

                {(showMemberDeleteModel && 
                    <DeleteMember 
                        selectedMemberToDelete={selectedMemberToDelete}
                        showDeleteModel={showMemberDeleteModel}
                        closeDeleteModel={this.closeDeleteModel}
                        getMemberList={this.getMemberList}
                    />
                )}

                {(showStudentDeleteModel && 
                    <DeleteStudent 
                        selectedStudentToDelete={selectedStudentToDelete}
                        showDeleteModel={showStudentDeleteModel}
                        closeDeleteModel={this.closeDeleteModel}
                        getStudentList={this.getStudentList}
                    />
                )}

                {showUploadPopup && 
                    <UploadExcelFile
                    closeModel={this.closeModel}
                    studentClicked={studentClicked}
                    closeSuccessModel={this.closeSuccessModel}
                    />
                }
            </div>
        );
    }
}

export default MemberList;